import { Injectable } from '@angular/core';
import * as CryptoJs from 'crypto-js';
import { ConfigService } from '../service/config.service'

@Injectable()
export class EncryptUtil {
    constructor(private configService: ConfigService) { }

    public getEncryptedData(messageToEncrypt: string): string {
        let Key = CryptoJs.enc.Utf8.parse(this.configService.getEncryptionKey());
        const encryptedData: string = CryptoJs.AES.encrypt(messageToEncrypt, Key, {
            mode: CryptoJs.mode.ECB,
            padding: CryptoJs.pad.Pkcs7
        }).ciphertext.toString();

        return encryptedData;
    }

    public decodeBase64(dataToDecode: string): string {
        return atob(dataToDecode);
    }
}
